
/*
 * Drill Bits Unlimited
 * Responsive product table swipe indicators
 */
(() => {
  const MOBILE_WIDTH = 749;
  const TABLE_SELECTOR = '.product__description table';
  const WRAPPER_CLASS = 'dbu-table-scroll';
  const HINT_CLASS = 'dbu-table-hint';

  function updateTables() {
    const mobile = window.innerWidth <= MOBILE_WIDTH;

    document.querySelectorAll(TABLE_SELECTOR).forEach((table) => {
      let wrapper = table.parentElement;

      // Use existing scrolling wrapper if present.
      const existingStyle = window.getComputedStyle(wrapper);
      const hasScrollWrapper =
        wrapper.classList.contains(WRAPPER_CLASS) ||
        (
          wrapper !== table.closest('.product__description') &&
          ['auto', 'scroll'].includes(existingStyle.overflowX)
        );

      // Remove any previous hint for this table.
      const previousHint = table.dataset.dbuHintId
        ? document.getElementById(table.dataset.dbuHintId)
        : null;

      if (previousHint) previousHint.remove();

      if (!mobile) return;

      // Add a dedicated wrapper if the table lacks one.
      if (!hasScrollWrapper) {
        const newWrapper = document.createElement('div');
        newWrapper.className = WRAPPER_CLASS;
        newWrapper.style.width = '100%';
        newWrapper.style.maxWidth = '100%';
        newWrapper.style.overflowX = 'auto';
        newWrapper.style.webkitOverflowScrolling = 'touch';

        table.parentNode.insertBefore(newWrapper, table);
        newWrapper.appendChild(table);
        wrapper = newWrapper;
      }

      // Check whether this table actually overflows.
      const needsScroll =
        wrapper.scrollWidth > wrapper.clientWidth + 2;

      if (!needsScroll) return;

      // Create instruction immediately before its table.
      const hint = document.createElement('div');
      const hintId =
        'dbu-table-hint-' +
        Array.from(document.querySelectorAll(TABLE_SELECTOR))
          .indexOf(table);

      hint.id = hintId;
      hint.className = HINT_CLASS;
      hint.innerHTML =
        '<span style="font-size:24px;font-weight:700;' +
        'vertical-align:middle;margin-right:8px;">&#8596;</span>' +
        '<span>Swipe horizontally to view all columns</span>';

      Object.assign(hint.style, {
        textAlign: 'center',
        fontSize: '13px',
        fontWeight: '600',
        padding: '10px',
        margin: '12px 0 6px',
        backgroundColor: '#f2f2f2',
        borderRadius: '5px',
        color: '#333'
      });

      wrapper.parentNode.insertBefore(hint, wrapper);
      table.dataset.dbuHintId = hintId;
    });
  }

  function initialize() {
    updateTables();

    let resizeFrame;
    window.addEventListener('resize', () => {
      cancelAnimationFrame(resizeFrame);
      resizeFrame = requestAnimationFrame(updateTables);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initialize);
  } else {
    initialize();
  }
})();
